import * as form from '../form';

export const financialEviction = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        EntityType: form.radio(xitem.EntityType),
        EntityTypeExplain: form.textarea(xitem.EntityTypeExplain),
        EntityName: form.text(xitem.EntityName),
        PrivateName: form.name(xitem.PrivateName),
        PropertyLocation: form.location(xitem.PropertyLocation),
        HasMissedRent: form.branch(xitem.HasMissedRent),
        FirstPastDue: form.datecontrol(xitem.FirstPastDue),
        NumberMissed: form.text(xitem.NumberMissed),
        NumberMissedEstimated: form.checkbox(xitem.NumberMissedEstimated),
        AmountOwed: form.number(xitem.AmountOwed),
        AmountOwedEstimated: form.checkbox(xitem.AmountOwedEstimated),
        Why: form.textarea(xitem.Why),
        When: form.datecontrol(xitem.When),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        CourtName: form.text(xitem.CourtName),
        CourtNameNotApplicable: form.notapplicable(xitem.CourtNameNotApplicable),
        CourtLocation: form.location(xitem.CourtLocation),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
        Current: form.branch(xitem.Current),
        WhenResolved: form.datecontrol(xitem.WhenResolved),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
      },
    };
  });
  return {
    HasEviction: form.branch(data.HasEviction),
    List: form.collection(items, (data.List || {}).branch),
  };
};
